import { useNavigate } from '@tanstack/react-router'
import { useEffect, useMemo } from 'react'
import getMetadata from '~utils/app/get-metadata'
import setMetadata from '~utils/app/set-metadata'
import Sentry from '~utils/sentry'

const useRedirectTo = () => {
  const navigate = useNavigate()
  const originMetadata = useMemo(() => JSON.parse(getMetadata() || '{}'), [])

  useEffect(() => {
    if (originMetadata.redirectTo) {
      const newMetadata = { ...originMetadata, redirectTo: undefined }
      setMetadata(newMetadata)

      switch (originMetadata.redirectTo) {
        case '/':
          navigate({ to: '/samsung/smart-things/login', replace: true, resetScroll: true })
          return
        case '/my-consultations':
          navigate({ to: '/samsung/smart-things/my-consultations', resetScroll: true })
          return
        case '/ask-a-vet':
          navigate({ to: '/samsung/smart-things/ask-a-vet', resetScroll: true })
          return
        default:
          Sentry.captureException(new Error('Invalid redirectTo'), {
            extra: {
              metadata: originMetadata,
            },
          })
      }
    }
  }, [navigate, originMetadata])
}

export default useRedirectTo
